// src/components/scan/header/ScanHeader.tsx
import { useIsMobile } from '../../../utils/isMobile';
import ScanHeaderDesktop from './ScanHeaderDesktop';
import ScanHeaderMobile from './ScanHeaderMobile';

interface Props {
  domain: string;
  loading: boolean;
}

export default function ScanHeader(props: Props) {
  const isMobile = useIsMobile();
  return isMobile ? (
    <ScanHeaderMobile {...props} />
  ) : (
    <ScanHeaderDesktop {...props} />
  );
}
